/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsmissingmenu3Inputs */

const en_listingbuttonsmissingmenu3 = /** @type {(inputs: Listingbuttonsmissingmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No menu yet –`)
};

const de_listingbuttonsmissingmenu3 = /** @type {(inputs: Listingbuttonsmissingmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Speisekarte –`)
};

/**
* | output |
* | --- |
* | "No menu yet –" |
*
* @param {Listingbuttonsmissingmenu3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsmissingmenu3 = /** @type {((inputs?: Listingbuttonsmissingmenu3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsmissingmenu3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsmissingmenu3(inputs)
	return de_listingbuttonsmissingmenu3(inputs)
});
export { listingbuttonsmissingmenu3 as "listingButtonsMissingMenu" }